import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#25C685',
        tapeBackgroundPrimary: '#21343b',
        tapeBackgroundSecondary: '#1a272e',
        accent: '#f44336',
        coloredSubText: '#96a7af',
        none: '#fff',
        tapeGreen: {
          base: '#25C685',
          lighten5: '#D4F5E9',
          disable: '#96a7af',
          lighten1: '#3dd598',
          sideText: '#666666',
        },
        tapeRed: {
          base: '#f44336',
          lighten1: '#e26261',
        },
        achromaticBase: '#43535e',
        achromaticBackground: '#282828',
        white: '#fff',
        white1: '#eee',
        white2: '#ddd',
        white3: '#ccc',
        white4: '#bbb',
        white5: '#aaa',
        black: '#000',
        black1: '#111',
        black2: '#222',
        black3: '#333',
        black4: '#444',
        black5: '#555',
        black6: '#666',
        black7: '#777',
        black8: '#888',
        black9: '#999',
      },
    },
  },
})
